export default __webpack_public_path__ + "static/media/no-activity.6448675b.svg";